import React, {useState, useEffect} from 'react';
import {TarjetaPresupuestos} from './TarjetaPresupuestos';
import {BotonesSuperiorPresupuestos} from './BotonesSuperiorPresupuestos';
import {listaPacientes} from './listaPacientes';
import {MenuLateralAA} from '../menuLateralAA/MenuLateralAA';
import {wait} from '@testing-library/user-event/dist/utils';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {useSessionStore} from '../../hooks/useSessionStore';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {animateScroll as scroll} from 'react-scroll';

import axios from 'axios';
/* Exporting the `ContentPresupuestos` function. */
export const ContentPresupuestos = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;

	const [FiltroNombre, setFiltroNombre] = useState('');
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Setting the state of the TipoNotificaciones variable to an array of strings. */
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		'buttonNotificacionesActive',
		'buttonNotificaciones',
		'buttonNotificaciones',
		'buttonNotificaciones',
	]);
	const [NumerServicios, setNumberServicios] = useState(0, 0, 0, 0);
	const [PageNumber, setPageNumber] = useState(1);
	const [CountPages, setCountPages] = useState(1);
	const [SiguientePagina, setSiguientePagina] = useState(false);

	/* Setting the state of the NumPresupuestos variable to an array of numbers. */
	const [NumPresupuestos, setNumPresupuestos] = useState([0, 0, 0, 0]);
	const [ListaPacientes, setListaPacientes] = useState([]);
	/** */
	const [ServicioId, setServicioId] = useState();
	/* Setting the state of the ListaPresupuesto variable to an array of objects. */
	const [ListaPresupuesto, setListaPresupuesto] = useState(listaPacientes());

	const [ServicioPacientes, setServicioPacientes] = useState([]);
	const [ModalRellenarHueco, setModalRellenarHueco] = useState(false);
	/**
	 * It sends a request to the server and waits for a response.
	 */
	/* Setting the state of the modalCancelarServicio variable to false. */
	const [modalCancelarServicio, setmodalCancelarServicio] = useState(false);
	/* It closes the modal window. */

	/* Setting the state of the modalActivar variable to false. */
	const [modalConfirmar, setmodalConfirmar] = useState(false);
	/* Setting the state of the modalActivar variable to false. */
	const [modalActivar, setmodalActivar] = useState(false);
	/* Setting the state of the EstadoActivacion variable to 0. */

	const {tarjetaRechazada, setTarjetaRechazada} = useState(false);

	const calcularNumeroPaginas = (numer) => {
		let basico = parseInt(numer / 5);
		let demas = numer % 5;
		if (demas != 0 || basico == 0) {
			basico++;
		}
		setCountPages(basico);
	};

	const getPresupuestos = (tipe, paginator) => {
		scroll.scrollToTop();
		let url = '';
		if (paginator !== null && paginator !== undefined) {
			url = window.ipdirection + tipe + '?page=' + paginator;
			setPageNumber(paginator);
		} else {
			url = window.ipdirection + tipe;
			setPageNumber(1);
		}
		axios({
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			method: 'get',
			url: url,
		})
			.then((response) => {
				if (response.data.next !== null) {
					setSiguientePagina(true);
				} else {
					setSiguientePagina(false);
				}
				console.log(response);
				calcularNumeroPaginas(response.data.count);
				calcularNotificaciones();
				getFotoPaciente(response.data.results);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getFotoPaciente = (lista) => {
		let listaServicios = [];
		setServicioPacientes([]);
		lista.map((servicio) => {
			axios({
				method: 'get',
				url:
					window.ipdirection +
					'imagenPerfilPaciente/?paciente_id=' +
					servicio.paciente_id.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			})
				.then((response) => {
					axios({
						method: 'get',
						url:
							window.ipdirection +
							'imagenPerfilPaciente/' +
							response.data[0].id +
							'/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						responseType: 'blob',
					})
						.then((response2) => {
							listaServicios.push({
								...servicio,
								paciente_id: {
									...servicio.paciente_id,
									fotoPaciente: URL.createObjectURL(response2.data),
								},
							});
							setServicioPacientes([...listaServicios]);
						})
						.catch((error) => {
							listaServicios.push({
								...servicio,
								paciente_id: {
									...servicio.paciente_id,
									fotoPaciente:
										'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
								},
							});
							setServicioPacientes([...listaServicios]);
						});
				})
				.catch((error) => {
					listaServicios.push({
						...servicio,
						paciente_id: {
							...servicio.paciente_id,
							fotoPaciente:
								'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
						},
					});
					setServicioPacientes([...listaServicios]);
				});
		});
	};

	const paginaAnterior = () => {
		if (PageNumber > 1) {
			const tipes = [
				'get_Presupuestos_Hoy',
				'get_Presupuestos_Pendientes',
				'get_Presupuestos_Por_Confirmar',
				'get_Presupuestos_All',
			];
			let contador = 0;
			TipoNotificaciones.map((notificacion) => {
				if (notificacion === 'buttonNotificacionesActive') {
					getPresupuestos(tipes[contador], PageNumber - 1);
				}
				contador++;
			});
		}
	};
	const paginaSiguiente = () => {
		if (SiguientePagina) {
			const tipes = [
				'get_Presupuestos_Hoy',
				'get_Presupuestos_Pendientes',
				'get_Presupuestos_Por_Confirmar',
				'get_Presupuestos_All',
			];
			let contador = 0;
			TipoNotificaciones.map((notificacion) => {
				if (notificacion === 'buttonNotificacionesActive') {
					getPresupuestos(tipes[contador], PageNumber + 1);
				}
				contador++;
			});
		}
	};

	/* A function that is called when the user clicks on one of 
    the buttons on the top of the page. */
	const cambioNotificaciones = (num) => {
		setPageNumber(1);
		setServicioPacientes([]);
		let listaAxu = [
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
		];
		listaAxu[num] = 'buttonNotificacionesActive';
		let listaAxu2 = [];
		let estado0 = 0;
		let estado1 = 0;
		let estado2 = 0;
		let estado3 = 0;
		/* A function that is called when the user clicks 
        on one of the buttons on the top of the page. */
		setTipoNotificaciones(listaAxu);
		const tipes = [
			'get_Presupuestos_Hoy',
			'get_Presupuestos_Pendientes',
			'get_Presupuestos_Por_Confirmar',
			'get_Presupuestos_All',
		];
		getPresupuestos(tipes[num]);
	};
	const getServiciosPacientes = () => {
		axios({
			url: window.ipdirection + 'servicioEmpresaPacienteEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			method: 'get',
		})
			.then((response) => {
				setServicioPacientes(response.data);
				cambioNotificaciones(0);
			})
			.catch((error) => {
				console.log(error.response.data);
			});
	};
	const calcularNotificaciones = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'numero_notificaciones_presatador/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setNumberServicios(response.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	/* Calling the function `cambioNotificaciones(0)` when the component is mounted. */
	useEffect(() => {
		getPresupuestos('get_Presupuestos_Hoy');
		cambioNotificaciones(0);
		getCuantosHay();
		calcularNotificaciones();
	}, []);

	const getCuantosHay = () => {
		return true;
	};

	const cancelarServicio = (id) => {
		setServicioId(id);
		setmodalCancelarServicio(true);
	};
	const rechazarServicio = (id) => {
		let Id;
		if (id === undefined) {
			Id = ServicioId;
		} else {
			Id = id;
		}
		axios({
			method: 'delete',
			url: window.ipdirection + 'servicioEmpresaPacienteEmpresa/' + Id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				getPresupuestos('get_Presupuestos_Por_Confirmar');
				cambioNotificaciones(0);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const eliminarServicio = (id) => {
		let Id;
		axios({
			method: 'put',
			url: window.ipdirection + 'servicioEmpresaPacienteEmpresa/' + id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {estado: 4},
		})
			.then((response) => {
				cambioNotificaciones(3);
				getPresupuestos('get_Presupuestos_All');
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const confirmar = (id) => {
		setServicioId(id);
		setmodalConfirmar(true);
	};
	const confirmarServicio = () => {
		console.log('confirmado');
		axios({
			method: 'put',
			url: window.ipdirection + 'servicioEmpresaPacienteEmpresa/' + ServicioId + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {estado: 2},
		})
			.then((response) => {})
			.catch((error) => {
				console.log(error);
			});
	};

	const bloquearEspacio = () => {
		let data = {};
		console.log(ServicioPacientes);
		ServicioPacientes.forEach((servicio) => {
			if (servicio.id === ServicioId) {
				data = {
					fechaServicio: servicio.fechaServicio,
					servicio_empresa: servicio.servicio_Empresa_id.id,
					hora_inicio: servicio.hora_inicio,
				};
			}
		});
		console.log(ServicioId, data);
		axios({
			method: 'post',
			url: window.ipdirection + 'servicioEmpresaVacioEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				cambioNotificaciones(0);
				setModalRellenarHueco(false);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const activarPresupuestos = (id) => {
		setServicioId(id);
		setmodalActivar(true);
	};
	const enviarEmailConfirmacion = (servicioId) => {
		let data = {
			servicio_empresa_paciente: ServicioId,
		};
		axios({
			method: 'post',
			url: window.ipdirection + 'enviar_Email_Confirmacion_Servicio/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {})
			.catch((error) => {
				console.log(error);
			});
	};
	const enviarServicio = () => {
		axios({
			method: 'put',
			url: window.ipdirection + 'servicioEmpresaPacienteEmpresa/' + ServicioId + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {estado: 1},
		})
			.then((response) => {
				setModalRellenarHueco(true);
				enviarEmailConfirmacion(ServicioId);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getEstado = () => {
		if (TipoNotificaciones[0] === 'buttonNotificacionesActive') {
			return 0;
		} else if (TipoNotificaciones[1] === 'buttonNotificacionesActive') {
			return 1;
		} else if (TipoNotificaciones[2] === 'buttonNotificacionesActive') {
			return 2;
		} else if (TipoNotificaciones[3] === 'buttonNotificacionesActive') {
			return 3;
		}
	};

	/********** Confirmar Pago ***********/

	const confirmPayment = async () => {
		let data = {
			servicio_empresa_paciente: ServicioId,
		};

		axios({
			method: 'post',
			url: window.ipdirection + 'confirm-payment/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				enviarServicio();
				setmodalActivar(false);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	/********** Cancelar Pago ***********/

	const cancelPayment = async () => {
		let data = {
			servicio_empresa_paciente: ServicioId,
		};

		axios({
			method: 'post',
			url: window.ipdirection + 'cancel-payment/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				setmodalCancelarServicio(false);
				rechazarServicio();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	/* Returning the `ContentPresupuestos` component. */
	return (
		<>
			<MenuLateralAB
				seleccionado={1}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<Modal
				centered={true}
				isOpen={modalConfirmar}
			>
				<ModalHeader> ¡Servicio completado!</ModalHeader>
				<ModalBody>
					<div className='descripcion-modal'>
						Gracias por completar el servicio para nuestro cliente. Se ha registrado la
						finalización del servicio en nuestra plataforma. Por favor, asegúrese de
						actualizar su información de pago para recibir su compensación. ¡Gracias por
						confiar en Cuidatia!
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='buttonB'
							onClick={() => {
								setmodalConfirmar(false);
							}}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button '
							onClick={() => {
								setmodalConfirmar(false);
								confirmarServicio();
							}}
						>
							<b>Activar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<Modal
				centered={true}
				isOpen={modalCancelarServicio}
			>
				<ModalHeader>Confirmación de rechazo de servicio</ModalHeader>
				<ModalBody>
					<div className='descripcion-modal'>
						Lo siento, no podemos proporcionar el servicio en este momento. Si hace clic
						en "Rechazar", se notificará al cliente que su solicitud ha sido rechazada.
						Para más información o preguntas, contacte con el equipo de soporte.
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='button'
							onClick={() => {
								setmodalCancelarServicio(false);
							}}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button borrarCuenta'
							onClick={() => {
								cancelPayment();
								//setmodalCancelarServicio(false);
								//rechazarServicio();
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<Modal
				centered={true}
				isOpen={ModalRellenarHueco}
			>
				<ModalHeader className='titulo-modal'>
					¿Quiere bloquear este espacio de tiempo?
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-modal'>
						Tras aceptar el servicio, puede dejar disponible el horario para futuros
						clientes o bloquearlo. Elija su preferencia.
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='buttonB'
							onClick={() => {
								bloquearEspacio();
								setModalRellenarHueco(false);
							}}
						>
							<b>Bloquear</b>
						</div>
						<div
							className='button'
							onClick={() => {
								getPresupuestos('get_Presupuestos_Por_Confirmar');
								cambioNotificaciones(0);
								setModalRellenarHueco(false);
							}}
						>
							<b>Dejar libre</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<Modal
				centered={true}
				isOpen={modalActivar}
			>
				<ModalHeader className='titulo-modal'>Confirmación de servicio</ModalHeader>
				<ModalBody>
					<div className='descripcion-modal'>
						¿Acepta el servicio? Al hacer clic en "Aceptar", confirma su disposición
						para proporcionárselo al cliente. Éste recibirá una notificación. Para más
						información o preguntas, contáctese con nuestro equipo de soporte.
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='buttonB'
							onClick={() => {
								setmodalActivar(false);
							}}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => {
								confirmPayment();
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={tarjetaRechazada}
			>
				<ModalHeader className='titulo-modal'>Ha ocurrido un error</ModalHeader>
				<ModalBody>
					<div className='descripcion-modal'>La tarjeta ha sido rechazada.</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='buttonB'
							onClick={() => {
								setmodalActivar(false);
							}}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => {
								enviarServicio();
								setmodalActivar(false);
							}}
						>
							<b>Cancelar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<div className='ContentPresupuestos'>
				{/* Esta es la posicon del boton qu se ha de estar seleccionado */}

				<div className='derContentPresupuestos'>
					<BotonesSuperiorPresupuestos
						TipoNotificaciones={TipoNotificaciones}
						setTipoNotificaciones={setTimeout}
						cambioNotificaciones={cambioNotificaciones}
						NumPresupuestos={NumPresupuestos}
						FiltroNombre={FiltroNombre}
						setFiltroNombre={setFiltroNombre}
						NumerServicios={NumerServicios}
						getPresupuestos={getPresupuestos}
					/>
					<div className='tarjetasPresupuestos'>
						<div className='listaTarjetas'>
							{ServicioPacientes.map((tarjetaPaciente) =>
								tarjetaPaciente.paciente_id.nombrePaciente
									.toLowerCase()
									.includes(FiltroNombre.toLowerCase()) ? (
									<TarjetaPresupuestos
										key={tarjetaPaciente.id}
										id={tarjetaPaciente.id}
										imagenPaciente={tarjetaPaciente.paciente_id.fotoPaciente}
										nombrePaciente={
											tarjetaPaciente.paciente_id.nombrePaciente +
											' ' +
											tarjetaPaciente.paciente_id.apellidosPaciente
										}
										telefono={tarjetaPaciente.paciente_id.telefonoPaciente}
										direccion={tarjetaPaciente.paciente_id.direccionPaciente}
										localidad={tarjetaPaciente.paciente_id.localidad}
										precio={tarjetaPaciente.servicio_Empresa_id.precioMin}
										fechaPaciente={tarjetaPaciente.paciente_id.fechaNacimiento}
										servicio={
											tarjetaPaciente.servicio_Empresa_id.servicio_id.nombre
										}
										horasMin={tarjetaPaciente.servicio_Empresa_id.horasMin}
										idPresupuesto={tarjetaPaciente.id}
										fecha={
											tarjetaPaciente.fechaServicio +
											' a las ' +
											tarjetaPaciente.hora_inicio
										}
										activarPresupuestos={activarPresupuestos}
										setmodalCancelarServicio={setmodalCancelarServicio}
										TipoNotificaciones={TipoNotificaciones}
										confirmar={confirmar}
										cancelarServicio={cancelarServicio}
										rechazarServicio={rechazarServicio}
										eliminarServicio={eliminarServicio}
									/>
								) : null
							)}
						</div>
						<div className='paginador-Presupuestos'>
							{PageNumber > 1 ? (
								<div
									className='button boton-paginador boton-paginador-anterior'
									onClick={paginaAnterior}
								>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='16'
										height='16'
										fill='currentColor'
										class='bi bi-caret-left-fill'
										viewBox='0 0 16 16'
									>
										<path d='m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z' />
									</svg>
								</div>
							) : (
								<div className='boton-paginador-vacio' />
							)}
							<div className='centrador'>
								<div className='numero-paginador'>
									{PageNumber} de {CountPages}
								</div>
							</div>
							{SiguientePagina ? (
								<div
									className='button boton-paginador boton-paginador-siguiente'
									onClick={paginaSiguiente}
								>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='16'
										height='16'
										fill='currentColor'
										class='bi bi-caret-right-fill'
										viewBox='0 0 16 16'
									>
										<path d='m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z' />
									</svg>
								</div>
							) : (
								<div className='boton-paginador-vacio' />
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
/**
 *
 * paciente:
 * nombre apellidos
 * telefono
 * direccion
 *
 * nombre servico
 * fehca del servcico
 * hora
 * precio
 *
 */
